let activeHighlightedMarkerId = null;

function markerRegistryId(element) {
    const id = element.dataset.leafletHoverId;
    const mapKey = element.dataset.leafletMapKey;

    return mapKey ? `${mapKey}:${id}` : id;
}

function resetMarker(markerId) {
    const marker = window.leafletMapMarkers?.[markerId];

    if (marker && marker.options.leafletDefaultIcon) {
        marker.setIcon(marker.options.leafletDefaultIcon);
    }
}

function highlightMarker(markerId) {
    const marker = window.leafletMapMarkers?.[markerId];

    if (!marker) {
        return;
    }

    const cluster = window.leafletMapMarkerClusters?.[markerId];
    const map = window.leafletMapMarkerMaps?.[markerId];
    const applyHighlight = () => {
        if (activeHighlightedMarkerId !== markerId) {
            return;
        }

        if (marker.options.leafletHoverIcon) {
            marker.setIcon(marker.options.leafletHoverIcon);
        }

        map?.panTo(marker.getLatLng());
    };

    if (map?.hasLayer(marker)) {
        applyHighlight();
    } else if (typeof cluster?.zoomToShowLayer === 'function') {
        cluster.zoomToShowLayer(marker, applyHighlight);
    } else {
        applyHighlight();
    }
}

function bindMarkerHover() {
    $(document)
        .off('mouseenter.leaflet-marker-hover', '[data-leaflet-hover-id]')
        .on('mouseenter.leaflet-marker-hover', '[data-leaflet-hover-id]', function () {
            const markerId = markerRegistryId(this);

            if (activeHighlightedMarkerId && activeHighlightedMarkerId !== markerId) {
                resetMarker(activeHighlightedMarkerId);
            }

            activeHighlightedMarkerId = markerId;
            highlightMarker(markerId);
        })
        .off('mouseleave.leaflet-marker-hover', '[data-leaflet-hover-id]')
        .on('mouseleave.leaflet-marker-hover', '[data-leaflet-hover-id]', function () {
            const markerId = markerRegistryId(this);

            if (activeHighlightedMarkerId === markerId) {
                activeHighlightedMarkerId = null;
            }

            resetMarker(markerId);
        });
}

function refreshLeafletMaps(container) {
    if (typeof window.L === 'undefined') {
        return;
    }

    $(container).find('[id^="leaflet_"]').each(function () {
        const mapId = this.id;
        const map = window[mapId.replace('leaflet_', 'leafletMap_')];
        const markerGroup = window[mapId.replace('leaflet_', 'leafletMarkerGroups_')];
        const initialBounds = window[mapId.replace('leaflet_', 'leafletInitialBounds_')];

        if (!map) {
            return;
        }

        map.invalidateSize();

        if (initialBounds?.isValid()) {
            map.fitBounds(initialBounds, {padding: [25, 25]});
        } else if (markerGroup?.getBounds) {
            const bounds = markerGroup.getBounds();

            if (bounds?.isValid()) {
                map.fitBounds(bounds, {padding: [25, 25]});
            }
        }
    });
}

function refreshLeafletMapsAfterLayout(container) {
    refreshLeafletMaps(container);
    setTimeout(() => refreshLeafletMaps(container), 100);
}

function setToggleLabel(button, view) {
    const icon = view === 'list' ? 'fa-map-marked-alt' : 'fa-list';
    const label = view === 'list' ? button.dataset.mapLabel : button.dataset.listLabel;

    button.replaceChildren();

    const iconElement = document.createElement('i');
    iconElement.className = `fal ${icon} me-2`;
    button.append(iconElement, label);
    button.dataset.view = view;
}

function createControlButton(className, iconClass, label) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = className;

    const icon = document.createElement('i');
    icon.className = iconClass;
    button.append(icon, label);

    return button;
}

function ensureSplitResultsControls(container) {
    let toggleButton = container.querySelector('.mobile-view-toggle');

    if (!toggleButton) {
        toggleButton = createControlButton(
            'btn btn-mobile-toggle mobile-view-toggle',
            'fal fa-map-marked-alt me-2',
            container.dataset.mapLabel || 'MAPA',
        );
        toggleButton.dataset.view = 'list';
        container.prepend(toggleButton);
    }

    toggleButton.dataset.mapLabel = container.dataset.mapLabel || toggleButton.dataset.mapLabel || 'MAPA';
    toggleButton.dataset.listLabel = container.dataset.listLabel || toggleButton.dataset.listLabel || 'LISTA';

    container.querySelectorAll('.sticky-map-wrapper').forEach((mapWrapper) => {
        if (mapWrapper.querySelector('.map-city-view-button')) {
            return;
        }
        mapWrapper.prepend(createControlButton(
            'btn btn-light btn-sm map-city-view-button',
            'fal fa-city me-2',
            container.dataset.mapResetLabel || 'Widok miasta',
        ));
    });

    return toggleButton;
}

function initializeSplitResultsMap(container) {
    if (container.dataset.splitResultsMapInitialized) {
        return;
    }

    container.dataset.splitResultsMapInitialized = 'true';

    const toggleButton = ensureSplitResultsControls(container);
    const isDesktop = () => window.matchMedia('(min-width: 992px)').matches;

    const setDesktopView = (view) => {
        const listColumns = container.querySelectorAll('.results-list-column');
        const mapColumns = container.querySelectorAll('.results-map-column');

        if (view === 'list') {
            $(listColumns).removeClass('col-lg-6').addClass('col-lg-12');
            $(mapColumns).addClass('d-none').removeClass('d-lg-block d-block');
            $(listColumns).find('.companies_box > .row').addClass('row-cols-xl-4');
            $(listColumns).find('.event-results-grid').removeClass('row-cols-lg-1').addClass('row-cols-lg-2');
            setToggleLabel(toggleButton, 'list');
            return;
        }

        $(listColumns).removeClass('d-none col-lg-12').addClass('col-lg-6');
        $(mapColumns).removeClass('d-none d-block').addClass('d-lg-block');
        $(listColumns).find('.companies_box > .row').removeClass('row-cols-xl-4');
        $(listColumns).find('.event-results-grid').removeClass('row-cols-lg-2').addClass('row-cols-lg-1');
        setToggleLabel(toggleButton, 'map');
        refreshLeafletMapsAfterLayout(container);
    };

    const setMobileView = (view) => {
        const listColumns = container.querySelectorAll('.results-list-column');
        const mapColumns = container.querySelectorAll('.results-map-column');

        $(listColumns).removeClass('col-lg-12').addClass('col-lg-6');
        $(listColumns).find('.companies_box > .row').removeClass('row-cols-xl-4');

        if (view === 'map') {
            $(listColumns).addClass('d-none');
            $(mapColumns).removeClass('d-none d-lg-block').addClass('d-block');
            setToggleLabel(toggleButton, 'map');
            refreshLeafletMapsAfterLayout(container);
            return;
        }

        $(listColumns).removeClass('d-none');
        $(mapColumns).addClass('d-none d-lg-block').removeClass('d-block');
        setToggleLabel(toggleButton, 'list');
    };

    let desktopView = isDesktop();
    desktopView ? setDesktopView('map') : setMobileView('list');

    $(window).off('resize.split-results-toggle').on('resize.split-results-toggle', () => {
        const nextDesktopView = isDesktop();

        if (desktopView === nextDesktopView) {
            return;
        }

        desktopView = nextDesktopView;
        desktopView ? setDesktopView('map') : setMobileView('list');
    });

    toggleButton.addEventListener('click', () => {
        const nextView = toggleButton.dataset.view === 'list' ? 'map' : 'list';
        isDesktop() ? setDesktopView(nextView) : setMobileView(nextView);
    });

    container.querySelectorAll('.map-city-view-button').forEach((button) => {
        button.addEventListener('click', (event) => {
            event.preventDefault();

            const mapSection = button.closest('[data-results-map-section]') || container;
            const mapElement = mapSection.querySelector('[id^="leaflet_"]');
            const map = mapElement && window[mapElement.id.replace('leaflet_', 'leafletMap_')];
            const initialBounds = mapElement && window[mapElement.id.replace('leaflet_', 'leafletInitialBounds_')];

            if (map && initialBounds?.isValid()) {
                map.invalidateSize();
                map.fitBounds(initialBounds, {padding: [25, 25]});
            }
        });
    });
}

function initializeSplitResultsMaps(root = document) {
    if (root instanceof Element && root.matches('.search-results-split-container')) {
        initializeSplitResultsMap(root);
    }

    root.querySelectorAll?.('.search-results-split-container').forEach(initializeSplitResultsMap);
}

$(function () {
    bindMarkerHover();
    initializeSplitResultsMaps();

    new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach(initializeSplitResultsMaps);
        });
    }).observe(document.body, {childList: true, subtree: true});
});
